import { render, staticRenderFns } from "./ReactMountLaboratorio.vue?vue&type=template&id=62b938bd"
import script from "./ReactMountLaboratorio.vue?vue&type=script&lang=ts"
export * from "./ReactMountLaboratorio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b938bd')) {
      api.createRecord('62b938bd', component.options)
    } else {
      api.reload('62b938bd', component.options)
    }
    module.hot.accept("./ReactMountLaboratorio.vue?vue&type=template&id=62b938bd", function () {
      api.rerender('62b938bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/ReactMountLaboratorio.vue"
export default component.exports